var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.01757812px",
    height: "13.8326491px",
    viewBox: "0 0 9.01757812 13.8326491",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tip-Tutorial",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-135.564453, -107.807002)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uDBC0\\uDEE6",
    transform: "translate(135.564453, 107.807002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.6832328 C0,7.95276405 0.205078125,8.1519828 0.4921875,8.1519828 L4.03710938,8.1519828 L2.18554688,13.0504203 C1.91601562,13.7535453 2.64257812,14.1226859 3.11132812,13.5543266 L8.84765625,6.57581093 C8.95898438,6.43518593 9.01757812,6.3004203 9.01757812,6.14807655 C9.01757812,5.8785453 8.80664062,5.67932655 8.52539062,5.67932655 L4.98046875,5.67932655 L6.83203125,0.780889052 C7.09570312,0.0836234271 6.36914062,-0.291376573 5.90039062,0.276982802 L0.169921875,7.25549843 C0.052734375,7.39612343 0,7.53088905 0,7.6832328 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.efa80df08db72f8d5abe983a7e674ce8.svg";
export { ForwardRef as ReactComponent };